import React, { Component } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    // Col,
    // Label,
} from "reactstrap";
import { StyledHeader } from "../../../styles";
import proworklogo from "./prowork favicon.png";
// import companyLogo from "../../../../../config/logo.png"
import MapContainer from "./MapContainer";
import { noImg } from "vrcore-dashboard/dist/utilities";
import {
    CropFree as QRIcon,
    PictureAsPdf as PDFIcon,
    Room as RoomIcon,
} from "@material-ui/icons";
import { Link } from "react-router-dom";
import {
    Button,
    List,
    ListItem,
    ListItemText,
    IconButton,
    TableRow,
    Card,
    Table,
    TableBody,
    Typography,
} from "@material-ui/core";
// import domToImage from 'dom-to-image';
// import { saveAs } from 'file-saver';
import { saveAsPng } from "save-html-as-image";
import "./equipment.css";
const QRCode = require("qrcode.react");

class ViewEquipmentModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            qrModal: false,
            locationModal: false,
        };
    }
    handleQrModal = () => {
        this.setState({ qrModal: true });
    };
    handleLocationModal = () => {
        this.setState({ locationModal: true });
    };
    takeScreenShot = () => {
        // domToImage.toBlob(document.getElementById('prin'))
        //     .then(function (blob) {
        //         window.saveAs(blob, 'qr.png');
        //     });
        const node = document.getElementById("prin");
        saveAsPng(node, { filename: "QRCode", printDate: true });
    };
    render() {
        const { isOpen, qr, allInfo, close } = this.props;

        let info_history = "";
        allInfo &&
            allInfo.map((info) => {
                return (
                    <>
                        {info.uid === qr.uid
                            ? (info_history = info.history)
                            : ""}
                    </>
                );
            });
        return (
            <>
                <Modal isOpen={isOpen}>
                    <ModalHeader>
                        View Equipment Details
                        <IconButton
                            style={{
                                border: "1px solid #0188cc",
                                color: "#0188cc",
                                marginRight: "10px",
                                marginLeft: "126px",
                            }}
                            onClick={() => {
                                this.handleLocationModal();
                            }}
                        >
                            <RoomIcon />
                        </IconButton>
                        <IconButton
                            style={{
                                border: "1px solid #0188cc",
                                color: "#0188cc",
                                marginRight: "10px",
                            }}
                            onClick={() => {
                                this.handleQrModal();
                            }}
                        >
                            <QRIcon />
                        </IconButton>
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            <img
                                style={{
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    display: "block",
                                    width: 220,
                                    height: 200,
                                    borderRadius: "12px",
                                    border: "2px solid #0188cc",
                                }}
                                src={qr.photo_url !== "" ? qr.photo_url : noImg}
                                alt={"icon"}
                            />
                        </div>
                        <br />
                        <h5 style={{ color: "#0188cc" }}>Equipment Details:</h5>
                        <div className="par halfwidth">
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>
                                    Description:
                                </b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {qr.description || "N/A"}
                                </p>
                            </div>
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>Name:</b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {qr.name || "N/A"}
                                </p>
                            </div>
                        </div>
                        <div className="par halfwidth">
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>Category:</b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {qr.category || "N/A"}
                                </p>
                            </div>
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>
                                    Service Period(months):
                                </b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {qr.service_period || "N/A"}
                                </p>
                            </div>
                        </div>
                        <div className="par halfwidth">
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>
                                    Thorough Examination Period(months):
                                </b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {qr.thorough_examination_period || "N/A"}
                                </p>
                            </div>
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>
                                    Date of Last Examination:
                                </b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {qr.date_last_examination || "N/A"}
                                </p>
                            </div>
                        </div>
                        <div className="par halfwidth">
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>
                                    Date of Last Service:
                                </b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {qr.date_last_service || "N/A"}
                                </p>
                            </div>
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>Status:</b>
                                <b
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                        color: checkOperational(qr.status),
                                    }}
                                >
                                    {qr.status || "N/A"}
                                </b>
                            </div>
                        </div>
                        <div
                            className="fullwidth"
                            style={{ background: "#f3f2f1" }}
                        >
                            <b style={{ fontSize: "small" }}>Inspection Due Date</b>
                            <br />

                            <p
                                style={{
                                    fontSize: "small",
                                }}
                            >
                                {qr.inspection_due_date}
                            </p>
                        </div>
                        <div
                            className="fullwidth"
                            style={{ background: "#f3f2f1" }}
                        >
                            <b style={{ fontSize: "small" }}>Notes:</b>
                            <br />

                            <p
                                style={{
                                    fontSize: "small",
                                }}
                            >
                                {qr.notes}
                            </p>
                        </div>
                        <div
                            className="fullwidth"
                            style={{ background: "#f3f2f1" }}
                        >
                            <b style={{ fontSize: "small" }}>Area's:</b>
                            {qr.area &&
                                qr.area.map((area) => {
                                    return (
                                        <p
                                            style={{
                                                display: "inline",
                                                fontSize: "small",
                                            }}
                                        >
                                            {area + "   " || "N/A"}
                                        </p>
                                    );
                                })}
                        </div>
                        <br />
                        <div
                            className="fullwidth"
                            style={{ background: "#f3f2f1" }}
                        >
                            <b style={{ fontSize: "small" }}>Department's:</b>
                            {qr.department &&
                                qr.department.map((department) => {
                                    return (
                                        <p
                                            style={{
                                                display: "inline",
                                                fontSize: "small",
                                            }}
                                        >
                                            {department + "   " || "N/A"}
                                        </p>
                                    );
                                })}
                        </div>

                        <br />
                        <h5 style={{ color: "#0188cc" }}>Attached Files:</h5>

                        {qr.attached_files && (
                            <List>
                                {qr.attached_files.map((e) => {
                                    return (
                                        <>
                                            {e.file_id !== undefined ? (
                                                <>
                                                    <Link
                                                        to={`pdf-viewer/file_manager/equipment_documents/${e.file_id}`}
                                                    >
                                                        <IconButton
                                                            style={{
                                                                border:
                                                                    "1px solid black",
                                                                color: "black",
                                                                marginRight:
                                                                    "10px",
                                                                marginLeft:
                                                                    "190px",
                                                            }}
                                                        >
                                                            <PDFIcon />
                                                        </IconButton>
                                                        <ListItem
                                                            style={{
                                                                textAlign:
                                                                    "center",
                                                            }}
                                                        >
                                                            <ListItemText
                                                                primary={e.file}
                                                            />
                                                        </ListItem>
                                                    </Link>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                        </>
                                    );
                                })}
                            </List>
                        )}
                        <br />
                        {info_history && info_history.length !== 0 ? (
                            <div>
                                <Card>
                                    <StyledHeader
                                        style={{ backgroundColor: "#0188CC" }}
                                    >
                                        <Typography
                                            variant="headline"
                                            style={{
                                                paddingLeft: "144px",
                                                fontWeigth: "bold",
                                                color: "white",
                                            }}
                                        >
                                            Cleaning History
                                        </Typography>
                                    </StyledHeader>
                                </Card>
                            </div>
                        ) : (
                            ""
                        )}
                        <div>
                            <Table>
                                <TableBody>
                                    {info_history &&
                                        Object.values(info_history).map(
                                            (history, index) => {
                                                return (
                                                    <TableRow key={index}>
                                                        <div
                                                            className="icon-text-container"
                                                            style={{
                                                                borderWidth:
                                                                    "medium",
                                                                border:
                                                                    "7px solid #0188cc",
                                                                borderRadius:
                                                                    "9px",
                                                                marginTop:
                                                                    "10px",
                                                            }}
                                                        >
                                                            <div className="float-left icon-container">
                                                                <img
                                                                    style={{
                                                                        borderRadius:
                                                                            "12px",
                                                                        width:
                                                                            "161px",
                                                                        height:
                                                                            "140px",
                                                                        marginTop:
                                                                            "2px",
                                                                        marginLeft:
                                                                            "108px",
                                                                        border:
                                                                            "2px solid #0188cc",
                                                                    }}
                                                                    src={
                                                                        history.photo_url ==
                                                                        null
                                                                            ? noImg
                                                                            : history.photo_url
                                                                    }
                                                                    alt="Proof"
                                                                />
                                                            </div>
                                                            <div className="float-left text-container">
                                                                <h5
                                                                    style={{
                                                                        border:
                                                                            "2px solid #0188cc",
                                                                        borderRadius:
                                                                            "12px",
                                                                        padding:
                                                                            "7px",
                                                                        width:
                                                                            "400px",
                                                                    }}
                                                                >
                                                                    <b>
                                                                        Last
                                                                        Cleaned:
                                                                    </b>{" "}
                                                                    <span className="subHeading">
                                                                        {
                                                                            history.timestamp
                                                                        }
                                                                    </span>
                                                                </h5>
                                                                <h5
                                                                    style={{
                                                                        border:
                                                                            "2px solid #0188cc",
                                                                        borderRadius:
                                                                            "12px",
                                                                        padding:
                                                                            "7px",
                                                                        width:
                                                                            "400px",
                                                                    }}
                                                                >
                                                                    <b>
                                                                        Last
                                                                        Cleaned
                                                                        By:
                                                                    </b>{" "}
                                                                    <span className="subHeading">
                                                                        {
                                                                            history.user_name
                                                                        }
                                                                    </span>
                                                                </h5>
                                                            </div>

                                                            <div className="clear"></div>
                                                        </div>
                                                    </TableRow>
                                                );
                                            }
                                        )}
                                </TableBody>
                            </Table>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button variant="contained" onClick={() => close()}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.locationModal}>
                    <ModalHeader closeButton>
                        Last Known Location
                        <Button
                            style={{ marginLeft: "190px" }}
                            variant="contained"
                            color="primary"
                            onClick={() =>
                                this.setState({ locationModal: false })
                            }
                        >
                            Close
                        </Button>
                    </ModalHeader>
                    {(qr.location_lat && qr.location_lon) === "" ? (
                        "No Location Available at this time"
                    ) : (
                        <MapContainer
                            lat={+qr.location_lat}
                            long={+qr.location_lon}
                        />
                    )}
                </Modal>
                <Modal isOpen={this.state.qrModal}>
                    <ModalHeader>View Equipment</ModalHeader>
                    <ModalBody>
                        <div id="prin" style={{ background: "white" }}>
                            <Row>
                                <TableRow style={{ display: "contents" }}>
                                    <img
                                        alt="profile avatar"
                                        src={proworklogo}
                                        style={{
                                            width: "103px",
                                            height: "80px",
                                            marginLeft: "16px",
                                            marginTop: "24px",
                                        }}
                                    />
                                    <QRCode
                                        id="QRCODE"
                                        bgColor="#FFFFFF"
                                        fgColor="#000000"
                                        level="Q"
                                        style={{
                                            height: "145px",
                                            width: "145px",
                                            marginLeft: "28px",
                                            marginRight: "23px",
                                        }}
                                        includeMargin={true}
                                        size={512}
                                        imageSettings={{
                                            height: 500,
                                            width: 500,
                                        }}
                                        value={qr.uid || ""}
                                        renderAs="canvas"
                                    />

                                    {/* <img
                                        src={companyLogo}
                                        alt="logo"
                                        style={{
                                            float: "right",
                                            width: "103px",
                                            height: "80px",
                                            marginLeft: "16px",
                                            marginTop: "28px",
                                            background:"#0288CC"
                                        }}
                                    /> */}
                                </TableRow>
                            </Row>
                            <p
                                style={{
                                    fontSize: "16px",
                                    marginLeft: "141px",
                                }}
                            >
                                <b>Name:</b> {qr.name}
                                <br />
                                <b>Status:</b> {qr.status}
                                <br />
                                <b
                                    style={{
                                        color: "red",
                                        marginLeft: "-45px",
                                    }}
                                >
                                    If Lost/Stolen Please Contact:{" "}
                                </b>
                                <br />
                                {/* <b style={{ color: "red" }}>or &nbsp;Email:</b> */}
                            </p>
                            <hr
                                style={{
                                    backgroundColor: "#0088CB",
                                    width: "100%",
                                    height: "5px",
                                    marginTop: "-11px",
                                }}
                            />
                        </div>
                        <div id="snap"></div>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            variant="contained"
                            onClick={() => {
                                this.takeScreenShot();
                            }}
                        >
                            Screenshot
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => this.setState({ qrModal: false })}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
export default ViewEquipmentModal;
const checkOperational = (status) => {
    if (status === "Operational" || status === "operational") {
        return "#008000";
    } else {
        return "";
    }
};
